import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

/**
 * Сессия — httpOnly cookie, поэтому токен не подставляется: запросу к API достаточно
 * withCredentials и (если канал выбран) заголовка X-As-Channel, указывающего, какая из
 * cookie (AS_FARMER/AS_STAFF) авторизует вызов. Явно заданный X-As-Channel не перетирается.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const channel = inject(AuthService).activeChannel();
  const setHeaders: Record<string, string> = {};
  if (channel && !req.headers.has('X-As-Channel')) {
    setHeaders['X-As-Channel'] = channel;
  }

  return next(req.clone({ withCredentials: true, setHeaders }));
};
